import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Environment } from '../interfaces';

/**
 * This service handles the environment in the ../... This work runtime.
 *
 * @export
 * @class EnvironmentService
 */
@Injectable()
export class EnvironmentService {
  /**
   * Public getter of the environment.
   *
   * @readonly
   * @type {Environment}
   * @memberof EnvironmentService
   */
  public get environment(): Environment {
    return this.cachedEnvironment;
  }

  /**
   * Relative path of the environment.
   *
   * @private
   * @memberof EnvironmentService
   */
  private readonly environmentPath = '/assets/environments/environment.json';

  /**
   * Relative path of the environment in production mode.
   *
   * @private
   * @memberof EnvironmentService
   */
  private readonly environmentProductionPath = '/assets/environments/environment.prod.json';

  /**
   * Internal, stored environment file.
   *
   * @private
   * @type {Environment}
   * @memberof EnvironmentService
   */
  private cachedEnvironment: Environment = {
    apiUrl: '',
    showNotifications: false,
  };

  constructor(private readonly http: HttpClient) {}

  /**
   * This function loads the environment runtime. This must be a Promise!
   *
   * @returns
   * @memberof EnvironmentService
   */
  public loadEnvironment() {
    return this.http
      .get(isDevMode() ? this.environmentPath : this.environmentProductionPath)
      .toPromise()
      .then((data) => {
        this.cachedEnvironment = data as Environment;
      })
      .catch(console.error);
  }
}
